import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

function MobileThreeDot(props) {
  const { title, open, closeHandler, children } = props;

  return (
    <Dialog
      data-testid="close"
      open={open}
      onClose={closeHandler}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={false}
      sx={{
        zIndex: 1600,
        '& .MuiDialog-container': {
          alignItems: 'flex-end'
        },
        '& .MuiDialog-paper': {
          margin: 0,
          borderRadius: '10px 10px 0 0',
          width: '100%'
        }
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <hr className="m-0" />
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
}

export default MobileThreeDot;
